<script setup lang="ts">
    import { inject, onMounted, onUnmounted, reactive, ref, toRaw } from 'vue';
    import { useRouter } from 'vue-router';
    import LoginForm from './LoginForm.vue';
    import RenewExpiredPasswordForm from './RenewExpiredPasswordForm.vue';
    import VerificationOtpForm from './VerificationOtpForm.vue';
    import RegistrationOtpForm from './RegistrationOtpForm.vue';
    import axios from 'axios';
    import { API_INFOS$, APP_INFOS } from '@/appService';

    const APP_ENV = inject('APP_ENV');
    const router = useRouter();
    const errorMessage = ref('');
    const loading = ref(false);
    const authResponse = reactive({
        token: '',
        password_expired: 1,
        mfa_enabled: 1
    });
    const currentViewName = ref<'LOGIN_VIEW' | 'RENEW_EXPIRED_PASSWORD' | 'REGISTRATION_OTP' | 'VERIFICATION_OTP'>('LOGIN_VIEW');
    const appInfos = reactive(APP_INFOS);
    const apiInfos = reactive({
        app_name: '',
        app_commit_sha: '',
        app_version: ''
    });

    onMounted(() => {
        const sub = API_INFOS$.subscribe(_apiInfos => {
            apiInfos.app_name = _apiInfos.app_name;
            apiInfos.app_commit_sha = _apiInfos.app_commit_sha;
            apiInfos.app_version = _apiInfos.app_version;
        });
        onUnmounted(() => sub.unsubscribe());
    })

    async function onAuthenticated(data: any) {
        authResponse.token = data.token;
        authResponse.password_expired = data.password_expired;
        authResponse.mfa_enabled = data.mfa_enabled;

        //if (APP_ENV == 'test') {
            redirectAuth();
        /*} else {
            if (data.password_expired == 1) {
                currentViewName.value = 'RENEW_EXPIRED_PASSWORD';
            } else if (data.mfa_enabled == 0) {
                currentViewName.value = 'REGISTRATION_OTP';
            } else {
                currentViewName.value = 'VERIFICATION_OTP';
            }
        }*/
    }

    function onPasswordRenewed() { 
        if (authResponse.mfa_enabled == 0) {
            currentViewName.value = 'REGISTRATION_OTP';
        } else {
            currentViewName.value = 'VERIFICATION_OTP';
        }
    }

    function onOtpRegistered() {
        currentViewName.value = 'VERIFICATION_OTP';
    }

    async function onOtpCodeVerified() {
        redirectAuth();
    }

    async function doGetAuthSession() {
        loading.value = true;
        errorMessage.value = '';
        try {
            const user = (await axios.get('/backoffice/auth/user', { headers: { Authorization: `Bearer ${authResponse.token}` } })).data;
            localStorage.setItem('LS_COOP_FINANCE_BO_ACCESS_TOKEN', authResponse.token);
            localStorage.setItem('LS_COOP_FINANCE_BO_AUTH_USER', JSON.stringify(user));
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    async function redirectAuth() {
        await doGetAuthSession();
        await router.replace('/app/dashboard');
    }

    function printAppInfos() {
        console.log("API INFOS", toRaw(apiInfos));
        console.log("APP INFOS", toRaw(appInfos));
    }
</script>

<template>
    <main class="cover-auth">
        <section class="s10_mobile px-4 py-4 h-100p">
            <div class="widget s20_mobile h-100p flex align-items-center justify-content-center" style="background: url('/images/bg-connexion.jpg') no-repeat center center; background-size: cover;">
                <img src="/icons/icon-menu-securite.svg" width="20%" class="icon-white" />
            </div>
        </section>
        <section class="s10_mobile flex flex-col justify-content-center h-100p container-full-5">

            <div class="container-full-10">
                <div class="text-center mb-8">
                    <img src="/images/logo.svg" width="60%" />
                </div>

                <login-form v-if="currentViewName == 'LOGIN_VIEW'" @authenticated="onAuthenticated"></login-form>
                <renew-expired-password-form 
                    :access-token="authResponse.token" 
                    @password-renewed="onPasswordRenewed" 
                    v-else-if="currentViewName == 'RENEW_EXPIRED_PASSWORD'">
                </renew-expired-password-form>
                <registration-otp-form 
                    :access-token="authResponse.token" 
                    @otp-registered="onOtpRegistered" 
                    v-else-if="currentViewName == 'REGISTRATION_OTP'">
                </registration-otp-form>
                <verification-otp-form 
                    :access-token="authResponse.token" 
                    @otp-verified="onOtpCodeVerified" 
                    v-else-if="currentViewName == 'VERIFICATION_OTP'">
                </verification-otp-form>
                <div @click="printAppInfos()" class="s20 text-center justify-content-center" style="cursor:pointer; margin-top: 50px; padding: 10px 30px; box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;">
                    <span>v{{ appInfos.app_version }}</span>
                </div>
            </div>

        </section>
    </main>
</template>
